import { Mitarbeiter } from '@/domain/navigation/benachrichtigungen/types/Benachrichtungen';
import dayjs from 'dayjs';

export class Fristen {
  constructor({
    id,
    mitarbeiter,
    gelesen,
    ablaufZeitpunkt,
    grund,
  }: {
    id: string;
    mitarbeiter: Mitarbeiter;
    gelesen: boolean;
    grund: string;
    ablaufZeitpunkt: dayjs.Dayjs;
  }) {
    this.id = id;
    this.ablaufZeitpunkt = ablaufZeitpunkt;
    this.grund = grund;
    this.gelesen = gelesen;
    this.mitarbeiter = mitarbeiter;
  }

  id: string;
  grund: string;
  gelesen: boolean;
  ablaufZeitpunkt: dayjs.Dayjs;
  mitarbeiter: Mitarbeiter;
}
